<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="640px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="考试名称："
        prop="courseExamName">
        <el-input v-model="info.courseExamName"></el-input>
      </el-form-item>
      <el-form-item
        label="考试时间："
        prop="examTime">
        <el-input v-model="info.examTime"></el-input>
      </el-form-item>
      <el-form-item
        label="可查询成绩："
        prop="queryScoreStatus">
        <el-switch
          v-model="info.queryScoreStatus"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'EditScoreModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        courseExamId: null,
        courseExamName: '',
        examTime: '',
        // stage: 1,
        queryScoreStatus: 0
      },
      rules: {
        courseExamName: [
          { required: true, message: '请输入考试名称', trigger: 'blur' },
          { max: 30, message: '考试名称长度最多 30 个字符', trigger: 'blur' }
        ],
        examTime: [
          { required: true, message: '请输入考试时间', trigger: 'blur' }
        ],
        queryScoreStatus: [
          { required: true, message: '请选择是否可查询成绩', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title() {
      const courseExamId = this.info.courseExamId
      return (courseExamId ? '编辑' : '新增') + '考试'
    },
    serviceProvinceCode() {
      return this.info.area[0] || null
    },
    serviceCityCode() {
      return this.info.area[1] || null
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        courseExamId: null,
        courseExamName: '',
        examTime: '',
        // stage: 1,
        queryScoreStatus: 0
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.courseExamId
            ? 'updatecourseexam'
            : 'addcourseexam'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.$message.success('保存成功')
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add() {
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
